import "./App.css";
import Login from "./component/login-page-component/LoginPage";
import { Navigate, Route, Routes } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import PrivateRoutes from "./component/utils/PrivateRoutes";
import "react-toastify/dist/ReactToastify.css";
import Home from "./Home";
import Dashboard from "./component/Dashboard/DashBoard";
import CleanUpMission from "./component/CleanUpMission/CleanUpMission";
import FishermanList from "./component/FisherManAdd/addFisherMan";
import DownloadReport from "./component/DownloadReport/downloadReport";

function App() {
  window.addEventListener("offline", () => {
    toast("Please Check your Internet Connection!!");
  });

  return (
    <div className="App">
      <Routes>
        <Route element={<PrivateRoutes />}>
          <Route path="/" element={<Home />}>
            <Route index element={<Dashboard />} />{" "}
            {/* This makes Dashboard the default */}
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="cleanup" element={<CleanUpMission />} />
            <Route path="fisherman-network" element={<FishermanList />} />
            <Route path="ocean-waste-report" element={<DownloadReport />} />
            {/* Add other routes here */}
          </Route>
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
        <Route path="/login" element={<Login />} />
      </Routes>

      <ToastContainer />
    </div>
  );
}

export default App;
